import React from 'react';
import { Box, Flex, Heading, Button, IconButton, Divider } from 'pounceV2';
import { LogStreamType } from 'Generated/schema';
import useSidesheetV3 from 'Hooks/useSidesheetV3';
import SetLogStreamTypeV3 from './SetLogStreamTypeV3';

export type SetLogStreamTypeSidesheetContentProps = {
  streamType: LogStreamType;
  excludeCloudwatch: boolean;
  streamTypes?: LogStreamType[];
  jsonArrayEnvelopeField?: string;
  xmlRootElement?: string;
  retainEnvelopeFields?: boolean;
  withEnvelopeField?: boolean;
  withXmlRootElement?: boolean;
  onSave: (
    logStreamType: LogStreamType,
    envelopeField?: string,
    xmlRootElement?: string,
    retainEnvelopeFields?: boolean,
  ) => void;
  onClose: () => void;
};

const SetLogStreamTypeSidesheetContentV3 = ({
  streamType,
  jsonArrayEnvelopeField,
  xmlRootElement,
  retainEnvelopeFields,
  onSave,
  excludeCloudwatch,
  streamTypes,
  withEnvelopeField,
  withXmlRootElement,
  onClose,
}: SetLogStreamTypeSidesheetContentProps) => {
  const [draftStreamType, setDraftStreamType] = React.useState(streamType);
  const [draftEnvelopeField, setDraftEnvelopeField] = React.useState(jsonArrayEnvelopeField);
  const [draftXmlRootElement, setDraftXmlRootElement] = React.useState(xmlRootElement);
  const [draftRetainEnvelopeFields, setDraftRetainEnvelopeFields] =
    React.useState(!!retainEnvelopeFields);
  const { hideSidesheet } = useSidesheetV3();

  React.useEffect(() => {
    setDraftStreamType(streamType);
  }, [streamType]);

  React.useEffect(() => {
    setDraftEnvelopeField(jsonArrayEnvelopeField);
  }, [jsonArrayEnvelopeField]);

  React.useEffect(() => {
    setDraftXmlRootElement(xmlRootElement);
  }, [xmlRootElement]);

  React.useEffect(() => {
    setDraftRetainEnvelopeFields(!!retainEnvelopeFields);
  }, [retainEnvelopeFields]);

  return (
    <Flex direction="column" height="100%">
      <Flex align="center" justify="space-between" gap={2} p={4} pb={2}>
        <Heading variant="h5">Edit Log Format</Heading>
        <Flex align="center" gap={2}>
          <Button
            onClick={() => {
              onSave(
                draftStreamType,
                draftEnvelopeField,
                draftXmlRootElement,
                draftRetainEnvelopeFields,
              );
              hideSidesheet();
            }}
          >
            Apply Selection
          </Button>
          <IconButton
            aria-label="Close Side Sheet"
            onClick={onClose}
            icon="close"
            variant="secondary"
          />
        </Flex>
      </Flex>
      <Divider />
      <Box sx={{ overflowY: 'auto', flex: 1 }}>
        <SetLogStreamTypeV3
          streamType={draftStreamType}
          excludeCloudwatch={excludeCloudwatch}
          streamTypes={streamTypes}
          retainEnvelopeFields={draftRetainEnvelopeFields}
          onStreamTypeChange={setDraftStreamType}
          onRetainEnvelopeFieldsChange={setDraftRetainEnvelopeFields}
          withEnvelopeField={withEnvelopeField}
          jsonArrayEnvelopeField={draftEnvelopeField}
          onEnvelopeFieldChange={setDraftEnvelopeField}
          withXmlRootElement={withXmlRootElement}
          xmlRootElement={draftXmlRootElement}
          onXmlRootElementChange={setDraftXmlRootElement}
        />
      </Box>
    </Flex>
  );
};

export default SetLogStreamTypeSidesheetContentV3;
